module.exports = __webpack_public_path__ + "static/Portrait-of-Oliver-min-cbc26762cb447188de9669391487c6f1.jpg";